var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveRejectDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68 11.2525L7.7 10.2725L9.52 8.4525L7.7 6.6325L8.68 5.6525L10.5 7.4725L12.32 5.6525L13.3 6.6325L11.48 8.4525L13.3 10.2725L12.32 11.2525L10.5 9.4325L8.68 11.2525ZM10.0625 4.9525L7.5775 2.4675L8.5575 1.4875L10.045 2.975L13.02 0L14 0.9975L10.0625 4.9525ZM0 9.1525V7.7525H6.3V9.1525H0ZM0 3.5525V2.1525H6.3V3.5525H0Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveRejectDisabledIcon);
export default __webpack_public_path__ + "static/media/approve_reject_disabled_icon.cac0b5f5ffe5a4eff5dcd623a7df00f9.svg";
export { ForwardRef as ReactComponent };